// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"889":"e8f91e22ebc745da","943":"9b00813f188fa806"}[chunkId] + ".js";
};